import Axios from "axios"
import consolidationApi from "./consolidation.api"
import customerApi from "./customer.api"
import dispatchApi from "./dispatch.api"
import dropApi from "./drop.api"
import fulfillmentApi from "./fulfillment.api"
import groupApi from "./group.api"
import linehaulApi from "./linehaul.api"
import authApi from "./login.api"
import menuApi from "./menu.api"
import orderApi from "./order.api"
import parcelApi from "./parcel.api"
import pickApi from "./pick.api"
import pricingApi from "./pricing.api"
import promoCodeApi from "./promoCode.api"
import purchaseRequestApi from "./purchaseRequest.api"
import shippingApi from "./shipping.api"
import suiteApi from "./suite.api"
import userApi from "./user.api"
import warehouseApi from "./warehouse.api"

const authApiInstance = Axios.create({
    baseURL: `${process?.env?.REACT_APP_BASE_URL_USERS}/api/`
})

const customerApiInstance = Axios.create({
    baseURL: `${process?.env?.REACT_APP_BASE_URL_CUSTOMERS}/api/`
})

const parcelApiInstance = Axios.create({
    baseURL: `${process?.env?.REACT_APP_BASE_URL_PARCELS}/api/`
})

const linehaulApiInstance = Axios.create({
    baseURL: `${process?.env?.REACT_APP_BASE_URL_PARCELS}/api/linehaul`
})

const shippingApiInstance = Axios.create({
    baseURL: `${process?.env?.REACT_APP_SHIPPING_SERVICES}/api/`
})

const paymentApiInstance = Axios.create({
    baseURL: `${process?.env?.REACT_APP_BASE_URL_PAYMENTS}/api/`
})

const securityApiInstance = Axios.create({
    baseURL: `${process?.env?.REACT_APP_BASE_URL_USERS}/api/`
})

const purchaseRequestApiInstance = Axios.create({
    baseURL: `${process?.env?.REACT_APP_BASE_URL_REQUESTS}/api/v1`
})

const pricingApiInstance = Axios.create({
    baseURL: `${process?.env?.REACT_APP_BASE_URL_PRICING}/api/`
})

export const attachAuthToken = (token: string) => {
    ;[
        customerApiInstance,
        parcelApiInstance,
        paymentApiInstance,
        securityApiInstance,
        purchaseRequestApiInstance,
        pricingApiInstance,
        linehaulApiInstance
    ]?.map((apiInstance) => {
        apiInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`
        apiInstance.defaults.headers.common["RequestSource"] = `parcel-hub`
    })
    localStorage.setItem("accessToken", token)
}

export interface GenericResponse {
    data: {
        data?: {
            status: boolean
            payload?: {
                data: Record<string, any>[]
            }
            error?: string
            code: number
            message?: string
        }
        status?: boolean
        error?: string
        code?: number
        payload?: any
        message?: string
    }
    status?: boolean
    error?: string
    code?: number
    payload?: any
    message?: string
}

export interface ShippingGenericResponse {
    data: {
        status: boolean
        payload?: string
        error?: string
        code: number
        message?: string
        id?: number
        label?: {
            success?: boolean
            msg?: string
            package?: {
                awb?: string
                company_id?: number
                label_path?: string
                tracking_number?: string
                log_id?: number
                parcel_id?: number
            }
        }
    }
    status?: number
    statusText?: string
    error?: string
    code?: number
    message?: string
}
export interface ErrorObject {
    location?: string
    msg: string
    param: string
    value: any
}

export interface GenericError {
    error?: string
    payload?: ErrorObject[]
}

// apis
export const auth = authApi(authApiInstance)
export const user = userApi(securityApiInstance)
export const parcel = parcelApi(parcelApiInstance)
export const promoCode = promoCodeApi(parcelApiInstance)
export const suite = suiteApi(parcelApiInstance)
export const consolidation = consolidationApi(parcelApiInstance)
export const drop = dropApi(parcelApiInstance)
export const pick = pickApi(parcelApiInstance)
export const dispatch = dispatchApi(parcelApiInstance)
export const warehouse = warehouseApi(securityApiInstance)
export const group = groupApi(securityApiInstance)
export const customer = customerApi(customerApiInstance)
export const menu = menuApi(securityApiInstance)
export const purchaseRequest = purchaseRequestApi(purchaseRequestApiInstance)
export const shipping = shippingApi(shippingApiInstance)
export const pricing = pricingApi(pricingApiInstance)
export const order = orderApi(parcelApiInstance)
export const linehaul = linehaulApi(linehaulApiInstance)
export const fulfillment = fulfillmentApi(parcelApiInstance)

const api = {
    auth,
    user,
    parcel,
    promoCode,
    suite,
    consolidation,
    drop,
    pick,
    dispatch,
    warehouse,
    group,
    customer,
    menu,
    purchaseRequest,
    shipping,
    pricing,
    order,
    linehaul,
    fulfillment
}

export default api
